export { default } from './contact-info.view';
